import { DirectUpload } from "activestorage";

import StorageService from "shared/services/StorageService";

export default class Uploader {
  constructor(file, url, { progress = () => {} } = {}) {
    this.file = file;
    this.url = url;
    this.accessToken = "";
    this.progressCallback = progress;
    this.cancelled = false;
    this.directUpload = new DirectUpload(this.file, this.url, this);
  }

  upload() {
    return new Promise((resolve, reject) => {
      StorageService.get("token")
        .then((token) => {
          this.accessToken = token;

          this.directUpload.create((error, blob) => {
            if (error) return reject(error);

            if (this.cancelled) {
              return reject(new Error("File upload was cancelled"));
            }

            return resolve(blob);
          });
        })
        .catch(reject);
    });
  }

  abort() {
    if (this.request) {
      this.request.abort();
    }

    this.cancelled = true;
  }

  directUploadWillCreateBlobWithXHR(request) {
    this.request = request;
    request.setRequestHeader("Authorization", `Bearer ${this.accessToken}`);
  }

  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress", this.progressCallback);
  }
}
